import { useContext } from "react";
import { HttpMethods } from "../../enums/HttpMethods";
import { NotificationTypes } from "../../enums/NotificationTypes";
import { BatteryEventDto } from "./dtos/BatteryEventDto";
import VspPortalContext from "../../store/VspPortalContext";
import { BatteryEventLatestDto } from "./dtos/BatteryEventLatestDto";
import { BatteryEventSummaryDto } from "./dtos/BatteryEventSummaryDto";
import { VspPortalActions } from "../../store/VspPortalActions";
import { useVspPortalHttp } from "../../hooks/useVspPortalHttp";



export const useBatteryEvents = (): {

    getBatteryEvents( doorCode: string, villageCode: string ): Promise<BatteryEventDto[] | null>
    , getBatteryEventsLatest( villageCode: string, events: string[ ] ): Promise<BatteryEventLatestDto[] | null>
    , getBatteryEventsSummary( villageCode: string ): Promise<BatteryEventSummaryDto[] | null>

} => {

    const { fetchData, getHttpOptions } = useVspPortalHttp( );
    const { dispatch, state } = useContext( VspPortalContext );


    const getBatteryEvents = async( doorCode: string, villageCode: string ): Promise<BatteryEventDto[] | null> => {

        
        const options = await getHttpOptions ( HttpMethods.Get, undefined );

        const query = `${process.env.REACT_APP_API_URL}/battery/event?doorCode=${doorCode}&villageCode=${villageCode}`;

        const response = await fetchData( options, query  );

        if ( response == null ) {

            dispatch({ type: VspPortalActions.SetNotificationType, payload: NotificationTypes.Error });
            dispatch({ type: VspPortalActions.SetNotificationText, payload: 'Error fetching battery events' });

            return null;

        }

        if ( response.statusCode === 200 ) {
        
            return await response.response?.json( );

        }

        dispatch({ type: VspPortalActions.SetNotificationType, payload: NotificationTypes.Error });
        dispatch({ type: VspPortalActions.SetNotificationText, payload: 'No data to display for the last 3 months' });

        return null;

    };


    const getBatteryEventsLatest = async( villageCode: string, events: string[ ] ): Promise<BatteryEventLatestDto[] | null> => {

        
        const options = await getHttpOptions ( HttpMethods.Get, undefined );

        const query = `${process.env.REACT_APP_API_URL}/battery/event/Latest?villageCode=${villageCode}&events=` + events.join( '&events=' );
        
        const response = await fetchData( options, query  );

        if ( response == null ) {

            dispatch({ type: VspPortalActions.SetNotificationType, payload: NotificationTypes.Error });
            dispatch({ type: VspPortalActions.SetNotificationText, payload: 'Error fetching latest battery events' });

            return null;

        }

        if ( response.statusCode === 200 ) {
        
            return await response.response?.json( );

        }

        return [ ];  
        
    };
    

    const getBatteryEventsSummary = async( villageCode: string ): Promise<BatteryEventSummaryDto[] | null> => {

        
        const options = await getHttpOptions ( HttpMethods.Get, undefined );

        const query = `${process.env.REACT_APP_API_URL}/battery/event/summary?villageCode=${villageCode}`;
        
        const response = await fetchData( options, query  );

        if ( response == null ) {

            dispatch({ type: VspPortalActions.SetNotificationType, payload: NotificationTypes.Error });
            dispatch({ type: VspPortalActions.SetNotificationText, payload: 'Error fetching battery events summary' });

            return null;

        }

        if ( response.statusCode === 200 ) {
        
            return await response.response?.json( );

        }

        return [ ];
        
    };


    return { 
        getBatteryEvents
        , getBatteryEventsLatest
        , getBatteryEventsSummary
    };

};
